import BaseModel from './base';

class BillingModel extends BaseModel {
	getInfo() {
		return this.get('');
	}

	validateVat(vat) {
		return this.get(`/validate-vat?vat=${vat}`);
	}

	async update(body) {
		return this.patch('/tax-information', { body });
	}

	async changePlan(body) {
		return this.patch('/tax-information', { body });
	}
}

export default new BillingModel('/billing');
